/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import UnpauseModal from 'app/components/Subscription/UnpauseModal.jsx';

class PauseBanner extends React.Component {
    constructor(props) {
        super(props);

        this.state = {           
            modalUp: false
        };

        this.unpause = this.unpause.bind(this);

    }

    unpause(e) {

        if (this.state.modalUp) {
            return;
        }

        this.props.addModal(
            <UnpauseModal
                {...this.props}
                dismissModal={() => {
                    this.props.closeAllModals()
                }}
                confirmUnpause={(e) => {
                    e.preventDefault();
                        
                    let user = this.props.user.detail,
                        constants = this.props.app.config.constants;
                
                    user.pauseButton = constants.PUB_PAUSE_OFF;
                     
                    this.props.updateUser(user);

                    this.props.closeAllModals();
                    
                }}/>
        );

    }

    render() {
        let action = (<Link to="/account">reactivate posting.</Link>),
            constants = this.props.app.config.constants;

        if (this.props.user.detail.pauseButton === constants.PUB_PAUSE_USER) {
            action = (<a href="#" onClick={this.unpause}>reactivate posting.</a>);
        }

        return (
            <div>
                <div className="icon-wrapper">
                    <i className="fa fa-warning banner-icon"/>
                </div>
                All posting has been paused. We won't check feeds or make posts until you {action}
            </div>
        );
    }
}

PauseBanner.displayName = "PauseBanner";

export default PauseBanner;
